export function getMatchingIds(data, services) {
    const result = [];
    data.forEach(first => {
        first.subServices.forEach(second => {
            second.subServices.forEach(third => {
                if (services.includes(third.id)) {
                    result.push(first.id);
                    result.push(second.id);
                    result.push(third.id);
                }
            });
        });
    });

    return ([...new Set(result)]);
}
